export default {
  // Mining stats
  mining_maxDepth0: {
    achievement: '这很深',
    description: '最大深度'
  },
  mining_maxDepth1: {
    achievement: '深入挖掘',
    description: '气态巨行星最大深度'
  },
  mining_maxDepthSpeedrun: {
    achievement: '深渊',
    description: '15 分钟内达到最大深度'
  },
  mining_depthDwellerCap0: {
    achievement: '垂直向下钻',
    description: '最大居民深度'
  },
  mining_depthDwellerCap1: {
    achievement: '无火花',
    description: '最大气体居民深度'
  },
  mining_totalDamage: {
    achievement: '毁灭',
    description: '造成的总伤害'
  },
  mining_maxDamage: {
    achievement: '力量',
    description: '一击造成最大伤害'
  },
  mining_craftingCount: {
    description: '精心制作的镐'
  },
  mining_scrap: {
    achievement: '垃圾堆',
    description: '获得的废料'
  },
  mining_oreTotal: {
    achievement: '更多矿石',
    description: '获得的矿石'
  },
  mining_oreVariety: {
    achievement: '多样性',
    description0: '发现的矿石类型',
    description1: '发现矿石和稀土类型',
    description2: '发现矿石、稀土和天然气类型',
  },
  mining_coal: {
    achievement: '黑暗',
    description: '获得的煤'
  },
  mining_resin: {
    achievement: '陷入困境',
    description: '得到的树脂'
  },
  mining_gasTotal: {
    achievement: '急性子',
    description: '最高气体量的数字总和'
  },
  mining_smoke: {
    achievement: '很难看清',
    description: '最高烟雾量'
  },
  mining_enhancementHighest: {
    achievement: '准备好了',
    description: '最高增强级别'
  },
  mining_craftingWasted: {
    achievement: '浪费了',
    description: '制作一把比你现在的镐更好的镐'
  },
  mining_dwellerCapHit: {
    achievement: '谷底',
    description: '达到最大居民深度'
  },
  mining_craftingLuck: {
    achievement: '百万分之一',
    description: '获得属性排名前 0.0001% 的镐'
  },
  mining_timeSpent: {
    description: '花费的时间'
  },
  mining_relicActivesUsed: {
    description: '遗物激活已使用'
  },
  mining_bestPrestige0: {
    description: '最佳声望 (矿山)'
  },
  mining_bestPrestige1: {
    description: '最佳声望 (气体巨人)'
  },
  mining_prestigeCount: {
    description: '声望'
  },

  // Village stats
  village_maxBuilding: {
    achievement: '摩天大楼',
    description: '已建成的建筑物'
  },
  village_basicResources: {
    achievement: '敲木头',
    description: '最高的木材数量、植物纤维数量或石材数量'
  },
  village_metal: {
    achievement: '铁锈和金属',
    description: '最高金属数量'
  },
  village_coin: {
    achievement: '资本家',
    description: '获得的硬币'
  },
  village_water: {
    achievement: '渡槽',
    description: '最高的水数量'
  },
  village_knowledge: {
    achievement: '策划者',
    description: '最高知识数量'
  },
  village_advancedResources: {
    achievement: '闪亮',
    description: '最高的硬木或宝石含量'
  },
  village_blessing: {
    achievement: '命中注定',
    description: '获得的祝福'
  },
  village_offering: {
    achievement: '虚无主义者',
    description: '获得的供品'
  },
  village_sacrifice: {
    achievement: '黑洞',
    description: '做出的牺牲'
  },
  village_oil: {
    achievement: '拿走他们的油!',
    description: '最高油数量'
  },
  village_highestPower: {
    achievement: '开灯',
    description: '最高电力'
  },
  village_minHappiness: {
    achievement: '生活在地狱里',
    description: '达到最低幸福感'
  },
  village_timeSpent: {
    description: '花费的时间'
  },
  village_relicActivesUsed: {
    description: '遗物激活已使用'
  },
  village_bestPrestige0: {
    description: '最佳声望 (工人)'
  },
  village_bestPrestige1: {
    description: '最佳声望 (工匠公会)'
  },
  village_prestigeCount: {
    description: '声望'
  },

  // Horde stats
  horde_maxZone: {
    achievement: '探险家',
    description: '最大区域'
  },
  horde_maxDifficulty: {
    description: '最大难度'
  },
  horde_maxZoneSpeedrun: {
    achievement: '迅捷出击',
    description: '30分钟内达到最大区域'
  },
  horde_totalDamage: {
    description: '造成的常规攻击总伤害'
  },
  horde_maxDamage: {
    achievement: '威猛',
    description: '一次常规攻击造成最大伤害'
  },
  horde_bone: {
    achievement: '狗的最爱',
    description: '获得的骨头'
  },
  horde_monsterPart: {
    achievement: '没有任何东西被浪费',
    description: '获得的怪物零件'
  },
  horde_soulCorrupted: {
    achievement: '灵魂的牧者',
    description: '获得的腐化灵魂'
  },
  horde_maxCorruptionKill: {
    achievement: '挑战邪恶',
    description: '击败最高腐化敌人'
  },
  horde_maxMastery: {
    achievement: '一招',
    description: '最高精通等级'
  },
  horde_totalMastery: {
    achievement: '多样性',
    description: '总计精通等级'
  },
  horde_blood: {
    achievement: '吸血鬼',
    description: '获得血液'
  },
  horde_courage: {
    achievement: '勇敢',
    description: '获得勇气'
  },
  horde_trinket: {
    achievement: '做好一切准备',
    description: '所有饰品稀有度的总和'
  },
  horde_unlucky: {
    achievement: '不幸',
    description: '失败有 99% 的传家宝几率'
  },
  horde_maxItems: {
    description: '最多装备使用'
  },
  horde_infiniteScore: {
    achievement: '角斗士',
    description: '在无尽的区域中击败的最高 # 敌人总数'
  },
  horde_warzoneInfiniteScore: {
    description: '在无尽区（Warzone）击败最高 # 敌人'
  },
  horde_monkeyJungleInfiniteScore: {
    description: '在无尽区域（猴子丛林）击败最高 # 敌人'
  },
  horde_loveIslandInfiniteScore: {
    description: '无限区域（爱之岛）击败最高 # 敌人'
  },
  horde_timeSpent: {
    description: '花费的时间'
  },
  horde_relicActivesUsed: {
    description: '遗物激活已使用'
  },
  horde_bestPrestige0: {
    description: '最佳声望 (装备)'
  },
  horde_bestPrestige1: {
    description: '最佳声望 (职业)'
  },
  horde_prestigeCount: {
    description: '声望'
  },

  // Farm stats
  farm_harvests: {
    achievement: '割草机',
    description: '总收成'
  },
  farm_maxOvergrow: {
    achievement: '园丁',
    description: '最佳收获'
  },
  farm_bestPrestige: {
    achievement: '享有盛誉',
    description: '最高作物声望'
  },
  farm_vegetable: {
    achievement: '素食主义者',
    description: '获得的蔬菜'
  },
  farm_berry: {
    achievement: '浆果不错',
    description: '获得的浆果'
  },
  farm_grain: {
    achievement: '面包师',
    description: '获得的谷物'
  },
  farm_flower: {
    achievement: '花店老板',
    description: '获得的鲜花'
  },
  farm_gold: {
    achievement: '单片眼镜',
    description: '获得的黄金'
  },
  farm_care: {
    achievement: '珍贵植物',
    description: '医疗应用'
  },
  farm_totalMystery: {
    description: '神秘'
  },

  // Gallery stats
  gallery_beauty: {
    achievement: '美丽',
    description: '获得的美丽'
  },
  gallery_converter: {
    achievement: '无限循环',
    description: '获得的转换器'
  },
  gallery_colorVariety: {
    achievement: '颜色多样性',
    description: '找到的颜色类型'
  },
  gallery_cash: {
    achievement: '富有',
    description: '获得的现金'
  },
  gallery_bestPrestige: {
    description: '一次声望中的最高现金'
  },
  gallery_highestTierIdea: {
    achievement: '脑洞大',
    description: '应用的最高层创意'
  },
  gallery_packageMax: {
    achievement: '纸板堡垒',
    description: '最高包包数量'
  },
  gallery_redDrumMax: {
    achievement: '笨蛋笨蛋笨蛋',
    description: '最高红鼓数量'
  },
  gallery_shapeComboTotal: {
    achievement: '收藏家',
    description: '收集的形状总数'
  },
  gallery_shapeComboHighest: {
    achievement: '天才',
    description: '最高形状组合'
  },
  gallery_canvasLevelTotal: {
    achievement: '远见卓识',
    description: '画布总等级'
  },
  gallery_hourglassHighest: {
    achievement: '借来的时间',
    description: '沙漏时间达到 1 天'
  },
  gallery_timeSpent: {
    description: '花费的时间'
  },
  gallery_relicActivesUsed: {
    description: '遗物激活已使用'
  },
  gallery_prestigeCount: {
    description: '声望'
  },

  // Other stats
  school_totalPoints: {
    description: '获得的总点数'
  },

  // Meta stats
  meta_totalLevel: {
    achievement: '优等生',
    description: '其他成就总等级'
  },
  meta_highestGrade: {
    achievement: '无所不知',
    description: '最好的学校成绩'
  },
  meta_longestOfflineTime: {
    achievement: '回来',
    description: '最长离线时长'
  },

  // Custom stats
  custom_hordeBattlepass: {
    description: '战斗通过等级'
  },
};
